import React from "react";
import PropTypes from "prop-types";
import { BodyStrong } from "theme/components/atoms/Typography/Body";

/** @type {React.FunctionComponent<PropTypes.InferProps<typeof propTypes>>} */
const EditorialToolboxSection = ({ title, children }) => {
  return (
    <section className="editorial-toolbox-section">
      <header className="editorial-toolbox-section__header">
        <BodyStrong>{title}</BodyStrong>
      </header>
      <div className="editorial-toolbox-section__content">{children}</div>
    </section>
  );
};

const propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

EditorialToolboxSection.propTypes = propTypes;

export default EditorialToolboxSection;
